export default __webpack_public_path__ + "static/media/news-8.c48acdce.jpg";